import { DateTime } from 'luxon'

export const CENTRAL_TIME_ZONE = 'America/Chicago'
export const EASTERN_TIME_ZONE = 'America/New_York'
export const DATE_AND_TIME_FORMAT = 'yyyy-MM-dd HH:mm ZZZZ'
export const DATE_FORMAT = 'yyyy-MM-dd'

export const getYesterday = () => DateTime.now().minus({ days: 1 })

export const getToday = () => DateTime.now()

export const getTomorrow = () => DateTime.now().plus({ days: 1 })

export const isDateBeforeToday = (dateInQuestion: string) => {
  return (
    DateTime.fromISO(dateInQuestion).startOf('day') < getToday().startOf('day')
  )
}

export const isDateAfterToday = (dateInQuestion: string) => {
  return (
    DateTime.fromISO(dateInQuestion).startOf('day') > getToday().startOf('day')
  )
}

export const isFirstDateBeforeSecondDate = (dateA: string, dateB: string) =>
  DateTime.fromISO(dateA).startOf('day') <
  DateTime.fromISO(dateB).startOf('day')

export const formatCentralDateToEastern = (centralDateTime: string) => {
  const utcDate = DateTime.fromISO(centralDateTime, { zone: CENTRAL_TIME_ZONE })
  const zonedDate = utcDate.setZone(EASTERN_TIME_ZONE)
  return zonedDate.toFormat(DATE_AND_TIME_FORMAT)
}

export const formatDateAndTime = (
  date: string,
  timeZone: string = EASTERN_TIME_ZONE
) => {
  return DateTime.fromISO(date, { zone: timeZone }).toFormat(
    DATE_AND_TIME_FORMAT
  )
}

export const formatDateAndTimeFromString = (
  date: string,
  format: string,
  timeZone: string = EASTERN_TIME_ZONE
) => {
  return DateTime.fromFormat(date, format, {
    zone: timeZone,
  }).toFormat(DATE_AND_TIME_FORMAT)
}

export const formatDate = (
  date: string,
  timeZone: string = EASTERN_TIME_ZONE
) => {
  return DateTime.fromISO(date, { zone: timeZone }).toFormat(DATE_FORMAT)
}

export const formatDateFromString = (
  date: string,
  format: string,
  timeZone: string = EASTERN_TIME_ZONE
) => {
  return DateTime.fromFormat(date, format, {
    zone: timeZone,
  }).toFormat(DATE_FORMAT)
}

// The ALPS gateway accepts option contract dates in ISO 8601 only (ACCM-6775).
// DatePickerInput hands back a Date when a day is picked and the raw text when
// one is typed, so both are normalized here.
const OPTION_CONTRACT_DATE_INPUT_FORMAT = 'M/d/yyyy'

export const toIsoCalendarDate = (
  value: Date | string | null | undefined
): string | undefined => {
  if (!value) {
    return undefined
  }
  const date =
    value instanceof Date
      ? DateTime.fromJSDate(value)
      : DateTime.fromFormat(value.trim(), OPTION_CONTRACT_DATE_INPUT_FORMAT)
  return date.isValid ? date.toFormat(DATE_FORMAT) : undefined
}

export const isBefore3pmEastern = () => {
  const threePmEasternHour = 15
  const currentEasternHour = new Date()
    .toLocaleTimeString('en-US', {
      timeZone: EASTERN_TIME_ZONE,
      hour12: false,
    })
    .split(':')[0]
  return Number(currentEasternHour) < threePmEasternHour
}
